import React from "react";
import { useGlobalSearchParams } from "expo-router";

import SaveFormFormProvider from "~/components/SaveForm/SaveForm.formProvider";

export default function SaveFormLayout() {
  const routeParams = useGlobalSearchParams();

  // TODO: For some reason params are nested when using `useLocalSearchParams` :shrug:
  // we freeze params cuz after push/replace within this stack, params can be lost
  const params = React.useRef(
    (routeParams ?? {}) as unknown as {
      spaceId?: string;
      saveId?: string;
    } & (
      | {
          type: "MEDIA";
          asset: string;
        }
      | {
          type: "URL";
        }
      | {
          type: "FILE";
          asset: string;
        }
    ),
  ).current;

  return <SaveFormFormProvider {...params} />;
}
